
    // HUD pill: subscribes to the MusicManager's state-change CustomEvent
    // instead of polling, so the pill updates instantly and stops running
    // when the page is idle.
    const pill = document.getElementById('musicState')
    function render(state) {
      if (!pill) return
      // `label` is the manager's short "L<level> S<song> <INTENSITY>" string.
      // The intensity word is inferred, not a name from the binary.
      const label = state && state.label
      if (label) {
        pill.hidden = false
        pill.textContent = label.toUpperCase()
      } else {
        pill.hidden = true
        pill.textContent = ''
      }
    }
    window.addEventListener('esoteria:musicState', (e) => {
      render(e.detail)
    })
  